import { render, staticRenderFns } from "./orgScholarsList.vue?vue&type=template&id=7edf12a2&scoped=true"
import script from "./orgScholarsList.vue?vue&type=script&lang=js"
export * from "./orgScholarsList.vue?vue&type=script&lang=js"
import style0 from "./orgScholarsList.vue?vue&type=style&index=0&id=7edf12a2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edf12a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edf12a2')) {
      api.createRecord('7edf12a2', component.options)
    } else {
      api.reload('7edf12a2', component.options)
    }
    module.hot.accept("./orgScholarsList.vue?vue&type=template&id=7edf12a2&scoped=true", function () {
      api.rerender('7edf12a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/comps/orgScholarsList.vue"
export default component.exports